import script from "./TheNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./TheNotification.vue?vue&type=script&setup=true&lang=js"

import "./TheNotification.vue?vue&type=style&index=0&id=f328ca5e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f328ca5e"]])

export default __exports__